import { CommonModule, NgOptimizedImage } from "@angular/common";
import { CUSTOM_ELEMENTS_SCHEMA, Component, OnInit } from "@angular/core";
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from "@angular/forms";
import { Router, RouterModule } from "@angular/router";
import { NgSelectModule } from "@ng-select/ng-select";
import { AuthService } from "../../services/auth.service";
import { BehaviorSubject } from "rxjs";
import { ToastrModule, ToastrService } from "ngx-toastr";
import { HeaderService } from "../../services/header.service";
import { HttpClient } from "@angular/common/http";
import { ApiHandlerService } from "../../services/apiCall.service";
import axios from "axios";
import { error } from "console";
import {LoadingComponent} from "../../../shared/loading/loading.component";

@Component({
  selector: "app-login",
  standalone: true,
    imports: [
        RouterModule,
        ReactiveFormsModule,
        CommonModule,
        FormsModule,
        NgSelectModule,
        NgOptimizedImage,
        LoadingComponent,
    ],
  templateUrl: "./login.component.html",
  styleUrl: "./login.component.scss",
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class LoginComponent implements OnInit {
  loginForm!: FormGroup;
  passwordToggle: boolean = false;
  // selecteValue = "us"
  submitted = false;
  isLoading$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
  disabled: boolean = false;
  btnLoader: boolean = false;
  rememberMevalue: any;

  countryDomains: any = [
    { countryCode: "ca", countryflag: "assets/images/ca-flag.svg" },
    { countryCode: "us", countryflag: "assets/images/us-flag.svg" },
    // { countryCode: "uk", countryflag: "assets/images/uk-flag.svg" },
  ];

  constructor(
    private router: Router,
    private fb: FormBuilder,
    private authService: AuthService,
    private toastr: ToastrService,
    private headerService: HeaderService,
    public httpClient: HttpClient,
    private service: ApiHandlerService
  ) {}
  userAuthentcataed: boolean = false;

  ngOnInit(): void {
    if (typeof window !== "undefined" && window.localStorage) {
      const storedUser = localStorage.getItem("rememberMe");
      const user = storedUser ? JSON.parse(storedUser) : null;
      this.initForm(user);
    } else {
      this.initForm(null);
    }
    this.getIpAddress();
    // this.getRegions();
  }

  initForm(value: any) {
    this.isLoading$.next(true);

    if (value) {
      this.loginForm = this.fb.group({
        email: [value.email, [Validators.required, Validators.email]],
        password: [value.password, [Validators.required]],
        country: [value.country],
        rememberMe: [value.rememberMe],
      });
      this.isLoading$.next(false);
    } else {
      this.loginForm = this.fb.group({
        email: ["", [Validators.required, Validators.email]],
        password: ["", [Validators.required]],
        country: [""],
        rememberMe: [false],
      });
    }
    this.isLoading$.next(false);
  }

  get f(): { [key: string]: AbstractControl } {
    return this.loginForm.controls;
  }

  onCLickLogin(formValues: any) {
    this.isLoading$.next(true);
    const rawFormValues = this.loginForm.getRawValue();
    this.disabled = true;
    this.btnLoader = true;
    const { value, valid } = formValues;
    if (value.rememberMe) {
      this.rememberMevalue = {
        email: value.email,
        password: value.password,
        country: value.country,
        initForm(value: any) {
          if (value) {
            this.loginForm = this.fb.group({
              email: [value.email, [Validators.required, Validators.email]],
              password: [value.password, [Validators.required]],
              country: [value.country],
              rememberMe: [value.rememberMe],
            });
          } else {
            this.loginForm = this.fb.group({
              email: ["", [Validators.required, Validators.email]],
              password: ["", [Validators.required]],
              country: [""],
              rememberMe: [false],
            });
          }
        },
      };
      localStorage.setItem("rememberMe", JSON.stringify(this.rememberMevalue));
    } else {
      localStorage.removeItem("rememberMe");
    }
    this.submitted = true;
    if (!valid) {
      this.isLoading$.next(false);
      this.btnLoader = false;
      this.disabled = false;
      return;
    }

    this.headerService.setSelectedCountry(rawFormValues.country).subscribe();
    localStorage.setItem("user", value.email);
    this.authService.login(value.email, value.password).subscribe(
      (response: any) => {
        this.isLoading$.next(false);
        this.btnLoader = false;
        this.disabled = false;
        this.headerService.setAuthentication(true);
        this.router.navigate(["/home"]);
      },
      (error: any) => {
        this.disabled = false;
        this.isLoading$.next(false);
        this.btnLoader = false;
      }
    );
  }
  togglePassword() {
    this.passwordToggle = !this.passwordToggle;
  }

  getRegions(ipAddresss: any) {
    axios
        .get(`https://ipapi.co/${ipAddresss}/json/`)
        .then((res: any) => {
          let data = res?.data;
          let code = this.countryDomains.some((domain: any) => {
            if (domain.countryCode == data?.country_code.toLowerCase()) {
              return true;
            }
            return false;
          });
          if (code) {
            this.f["country"].setValue(data.country_code.toLowerCase());
          } else {
            this.f["country"].setValue("us");
          }
        })
        .catch((error: any) => {
          this.f["country"].setValue("us");
        });
  }

  getIpAddress() {
    axios
      .get(`https://api.ipify.org/?format=json`)
      .then((data: any) => {
        this.getRegions(data?.data?.ip);
      })
      .catch((error: any) => {});
  }
}
